export default "__VITE_ASSET__CRFRGdDX__"